import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse } from '../../../shared/models/api-response.model';
import { Attachment } from '../../../shared/models/attachment';
import { SelectList } from '../../../shared/models/select-list';
import { HttpCommonService } from '../../../shared/services/http-common-service';
import { ProcessActionDto } from '../model/process-action-dto';
import { SaveRequestDecisionDto } from '../model/request-decision-dto';
import { RequestHistoryDto } from '../model/request-history-dto';
import { InboxVM } from '../model/search-inbox-dto';
import { SearchRequestVM } from '../model/search-request-dto';
import { MainRequestDetailsDto } from '../model/main-request-details.dto';
import { InboxDashboardDto } from '../model/inbox-dashboard-dto';

@Injectable({
  providedIn: 'root',
})
export class WorkflowService {
  baseUrl = 'Workflow';

  constructor(private http: HttpClient,
    private httpCommonService: HttpCommonService) { }

  
  getRequestsList(
    searchObjVM?: SearchRequestVM
  ): Observable<ApiResponse<SearchRequestVM>> {
    return this.http.post<ApiResponse<SearchRequestVM>>(
      this.baseUrl + '/GetRequestsList',
      searchObjVM
    );
  }

  getInboxCount(): Observable<ApiResponse<string>> {
    return this.http.get<ApiResponse<string>>(
      this.baseUrl + '/GetInboxCount'
    );
  }

  getMyTasksCount(): Observable<ApiResponse<number>> {
    return this.http.get<ApiResponse<number>>(
      this.baseUrl + '/GetMyTasksCount'
    );
  }

  getInboxDashboard(): Observable<ApiResponse<InboxDashboardDto>> {
    return this.http.get<ApiResponse<InboxDashboardDto>>(
      this.baseUrl + '/GetInboxDashboard'
    );
  }

  getInbox(searchObjVM?: InboxVM): Observable<ApiResponse<InboxVM>> {
    return this.http.post<ApiResponse<InboxVM>>(
      this.baseUrl + '/GetInboxList',
      searchObjVM
    );
  }

  getRequestActions(requestId: string): Observable<ApiResponse<ProcessActionDto[]>> {
    return this.http.get<ApiResponse<ProcessActionDto[]>>(
      this.baseUrl + '/GetActivityActions?baseRequestId=' + requestId
    );
  }

  getRequestHistory(requestId: string): Observable<ApiResponse<RequestHistoryDto[]>> {
    return this.http.get<ApiResponse<RequestHistoryDto[]>>(
      this.baseUrl + '/GetRequestHistory?baseRequestId=' + requestId
    );
  }

  saveRequestDecision(
    model?: SaveRequestDecisionDto
  ): Observable<ApiResponse<string>> {
    return this.http.post<ApiResponse<string>>(
      this.baseUrl + '/SaveRequestDecision',
      model
    );
  }

  getMainRequestDetails(requestId: string): Observable<ApiResponse<MainRequestDetailsDto>> {
    return this.http.get<ApiResponse<MainRequestDetailsDto>>(
      this.baseUrl + '/GetMainRequestDetails?id=' + requestId
    );
  }

  //getRequestOwner(requestId: string): Observable<ApiResponse<RequestOwnerDto>> {
  //  return this.http.get<ApiResponse<RequestOwnerDto>>(
  //    this.baseUrl + `/GetRequestOwnerDetails/${requestId}`
  //  );
  //}

  cancelRequest(requestId: string): Observable<ApiResponse<boolean>> {
    return this.http.get<ApiResponse<boolean>>(
      this.baseUrl + '/CancelRequest?id=' + requestId
    );
  }

  deleteRequestAttachment(
    attachmentId: string
  ): Observable<ApiResponse<boolean>> {
    return this.http.delete<ApiResponse<boolean>>(
      this.baseUrl + '/DeleteRequestAttachment?id=' + attachmentId
    );
  }

  getRequestAttachments(
    requestId: string
  ): Observable<ApiResponse<Attachment[]>> {
    return this.http.get<ApiResponse<Attachment[]>>(
      this.baseUrl + '/GetRequestAttachments?baseRequestId=' + requestId
    );
  }

  addRequestAttachments(
    requestId: string,
    file: File,
  ): Observable<ApiResponse<Attachment>> {
    let formData = new FormData();
    formData.append('baseRequestId', requestId);
    formData.append('file', file, file.name);
    return this.http.post<ApiResponse<Attachment>>(
      this.baseUrl + '/AddRequestAttachment',
      formData
    );
  }

  getRequestStatusList(
    processId?: number
  ): Observable<ApiResponse<SelectList[]>> {
    if (processId == null)
      return this.http.get<ApiResponse<SelectList[]>>(
        'Workflow/GetRequestStatusList'
      );
    else
      return this.http.get<ApiResponse<SelectList[]>>(
        'Workflow/GetRequestStatusList?processId=' + processId
      );
  }

  getRequestTypesList(): Observable<ApiResponse<SelectList[]>> {
    return this.http.get<ApiResponse<SelectList[]>>(
      'Workflow/GetRequestTypesList'
    );
  }

  exportRequests(searchRequestVM: SearchRequestVM): Observable<Blob> {
    return this.httpCommonService.post({ url: this.baseUrl + "/ExportRequests", body: searchRequestVM, responseType: 'blob' });
  }

  exportInbox(searchObjVM: InboxVM): Observable<Blob> {
    return this.httpCommonService.post({ url: this.baseUrl + "/ExportInbox", body: searchObjVM, responseType: 'blob' });
  }
}
